export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-label="Szukaj">
        <path d="m21 21-4.34-4.34" />
        <circle cx="11" cy="11" r="8" />
    </svg>
);

export const SearchIconV2 = () => (
    <svg>
        <use xlinkHref="#search-v2" />
    </svg>
);
